import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import type { ReviewWithSearchableFields } from "@/reviews/review";
import type { IReview } from "@/reviews/review";
import { getEnrichedReview } from "./utils";

export const businessReviewsKey = (businessId?: string | null) =>
  ["business-reviews", businessId] as const;

export const reviewKey = (reviewId?: string | null) =>
  ["activity-review", reviewId] as const;

export const useGetBusinessReviews = (businessId?: string | null) => {
  const { get } = useApi();

  return useQuery<ReviewWithSearchableFields[]>({
    queryKey: businessReviewsKey(businessId),
    queryFn: () =>
      get(`/businesses/${businessId}/reviews`).then((res) =>
        res.data.map(getEnrichedReview),
      ),
    enabled: !!businessId,
  });
};

export const useGetReview = (
  businessId?: string | null,
  reviewId?: string | null,
  enabled = true,
) => {
  const { get } = useApi();

  return useQuery({
    queryKey: reviewKey(reviewId || ""),
    queryFn: () =>
      get(`/businesses/${businessId}/reviews/${reviewId}`).then(
        (res) => res.data as IReview,
      ),
    enabled: !!businessId && !!reviewId && enabled,
  });
};
